<template>
    <!-- Activity 弹窗 -->
    <a-modal v-model:visible="modalVisible" wrapClassName="activity-modal" :width="modalWidth" :footer="null" :centered="true">
        <template #title>
            <span class="px-35 lg:(j-px-40 j-text-30 j-leading-50) text-black Poppins-SemiBold font-semibold">{{ title }}</span>
        </template>
        <template v-if="countryLoading">
            <div class="px-35 flex lg:j-px-40 text-primary lg:j-text-20"><loading-outlined /> &nbsp; {{ t('tips.loading') }}</div>
        </template>
        <template v-else>
            <ul class="mx-35 flex gap-50 pb-[6px] lg:(j-mx-40 j-gap-35) overflow-x-auto">
                <li
                    class="group lg:j-text-20 Poppins-SemiBold font-semibold cursor-pointer flex-shrink-0"
                    v-for="item in countryList"
                    :class="item === activeCountry ? 'active' : ''"
                    @click.prevent="switchCountry(item)"
                >
                    <span class="country-item">{{ item }}</span>
                </li>
            </ul>
        </template>
        
        <div class="px-30 pt-20 pb-30 lg:j-px-15 lg:j-pt-20 lg:j-pb-30 overflow-hidden">
            <template v-if="logLoading">
                <div class="w-full flex-center flex-col h-638 px-30 lg:(j-h-534 j-px-30) rounded-12 lg:j-rounded-8 bg-white text-primary">
                    <loading-outlined /> &nbsp; {{ t('tips.loading') }}
                </div>
            </template>
            <template v-else>
                <div v-if="logList.length" class="w-full h-auto bg-white rounded-12 lg:j-rounded-8 py-30 lg:j-py-30">
                    <div class="list-header">
                        <span class="w-35%">{{ t('member_index.banner.time') }}</span>
                        <span class="w-40%">{{ t('member_index.banner.action') }}</span>
                        <span class="w-25% text-end">{{ t('member_index.banner.points') }}</span>
                    </div>
                    <ul class="h-520 px-30 lg:(j-h-420 j-px-30) overflow-y-auto">
                        <li
                            class="list-item"
                            v-for="{ time, type, point, } in logList"
                        >
                            <span class="w-35% zoom-83.3333333333333 lg:zoom-0">{{ time }}</span>
                            <span class="w-40% zoom-83.3333333333333 lg:zoom-0">{{ type }}</span>
                            <span class="w-25% text-end zoom-83.3333333333333 lg:zoom-0">{{ point }} {{ t('member_index.common.points') }}</span>
                        </li>
                    </ul>
                </div>
                <div v-else class="w-full flex-center flex-col h-638 px-30 lg:(j-h-534 j-px-30) rounded-12 lg:j-rounded-8 bg-white">
                    <img
                        class="w-417 h-218 lg:(j-w-313 j-h-209) object-cover"
                        src="https://cdn.shopifycdn.net/s/files/1/0550/0524/9633/files/lQLPJyA8mmi9M3rNAanNAmiw7oeyMcQSICUEZ4ZgpQASAA_616_425.png?v=1685097827"
                        alt=""
                    >
                    <p class="mt-55 text-32 leading-32 lg:(j-mt-40 j-text-24 j-leading-24) text-black Poppins-SemiBold font-semibold">{{ t('member_index.banner.no_activity_records') }}</p>
                </div>
            </template>
        </div>
    </a-modal>
</template>

<script setup>
    import { getAccountPoint, getAccountPointsDetail, } from '@a/index'
    import { LoadingOutlined, } from '@ant-design/icons-vue'
    import { useWindowSize } from '@vueuse/core'
    import { useI18n } from "vue-i18n"
    import { gaPushDataLayer } from '@/utils/ga.js'
    import { useRoute } from 'vue-router'
    import { useStore } from 'vuex'

    const { t } = useI18n()
    const $route = useRoute()
    const store = useStore()
    const userInfo = computed(() => store.getters.userInfo);

    const props = defineProps({
        title: String,
    })

    const { width } = useWindowSize()
    const modalWidth = computed(() => width.value < 1024 ? (width.value / 7.5) * 9.2 : (width.value / 19.2) * 9.2)

    const countryLoading = ref(true)
    const logLoading = ref(true)

    const activeCountry = ref('')
    const countryList = ref([])
    const logList = ref([])

    const modalVisible = ref(false)
    const openModal = async () => {
        modalVisible.value = true

        countryLoading.value = true
        logLoading.value = true
        try {
            const data = await getAccountPoint()
            countryList.value = data?.length ? data : []

            countryList.value[0] && switchCountry(countryList.value[0])
        } finally {
            countryLoading.value = false
        }
    }

    // 获取积分明细
    const getPointsDetail = async (cr) => {
        logLoading.value = true
        logList.value = []
        try {
            const { count, data = [], } = await getAccountPointsDetail({
                page: 1,
                limit: 10000,
                cr,
            })
            logList.value = data
        } finally {
            logLoading.value = false
        }
    }

    // 切换国家
    const switchCountry = (cr) => {
        const params = {
            jackery_id: userInfo.value.userName,
            position: t($route.meta.title),
            title: props.title,
            country: cr
        }
        gaPushDataLayer( params)
        activeCountry.value = cr
        getPointsDetail(cr)
    }


    defineExpose({
        openModal,
    })
</script>

<style scoped>
    .country-item {
    @apply
        group-[.active]:(text-primary underline underline-offset-6)
        lg:(j-text-20 j-leading-32 j-py-4) Poppins-Semibold font-semibold cursor-pointer
    }
    .list-header {
    @apply
        flex Poppins-Semibold font-semibold text-black text-24 leading-36 lg:j-text-20 lg:j-leading-32
        pb-20 lg:j-pb-20 px-30 lg:j-px-30 border-0 !border-b-1 border-solid border-#E6E6E6
    }
    .list-item {
    @apply
        flex Poppins-Normal font-normal text-regular text-20 leading-36 lg:j-text-14 lg:j-leading-32
        py-10 lg:j-py-10 border-0 !border-b-1 border-solid border-#E6E6E6
    }
</style>
